import './style.scss';
import { TranslationService } from '../../../../services/translation.service';
import { StepComponentType } from '../../step-component-type.enum';

export default function StepIndicator({ currentStep }: { currentStep: StepComponentType }) {
  return (
    <div className="step-indicator">
      <div className="step-indicator-bars d-flex flex-row mb-2">
        <div className="step-indicator-bar-dot-wrapper step-indicator-bar-dot-wrapper--left d-flex justify-content-center">
          <div className="step-indicator-bar-dot-wrapper__step-indicator-bar-dot">
            <StepIndicatorBar stepType={StepComponentType.TravelInformationStep} currentStep={currentStep} />
          </div>
        </div>
        <div className="step-indicator-bar-dot-wrapper step-indicator-bar-dot-wrapper--center d-flex justify-content-center">
          <div className="step-indicator-bar-dot-wrapper__step-indicator-bar-dot">
            <StepIndicatorBar stepType={StepComponentType.CarInformationStep} currentStep={currentStep} />
          </div>
        </div>
        <div className="step-indicator-bar-dot-wrapper step-indicator-bar-dot-wrapper--right d-flex justify-content-center">
          <div className="step-indicator-bar-dot-wrapper__step-indicator-bar-dot">
            <StepIndicatorBar stepType={StepComponentType.ResultStep} currentStep={currentStep} />
          </div>
        </div>
      </div>

      <div className="step-indicator-headings d-flex">
        <div className={`step-indicator-headings__text ${currentStep === StepComponentType.TravelInformationStep ? 'step-indicator-headings__text--active' : ''} text-center`}>
          1. {TranslationService.get('pricecalculatorpage.travelinformationheading')}
        </div>
        <div className={`step-indicator-headings__text ${currentStep === StepComponentType.CarInformationStep ? 'step-indicator-headings__text--active' : ''} text-center`}>
          2. {TranslationService.get('pricecalculatorpage.carinformationheading')}
        </div>
        <div className={`step-indicator-headings__text ${currentStep === StepComponentType.ResultStep ? 'step-indicator-headings__text--active' : ''} text-center`}>
          3. {TranslationService.get('pricecalculatorpage.resultheading')}
        </div>
      </div>
    </div>
  );
}

function StepIndicatorBar({ stepType, currentStep }: { stepType: StepComponentType; currentStep: StepComponentType }) {
  if (currentStep === stepType) {
    return <div className="step-indicator-bar-dot-wrapper__step-indicator-bar-dot step-indicator-bar-dot-wrapper__step-indicator-bar-dot--active"></div>;
  }
  if (currentStep > stepType) {
    return <div className="step-indicator-bar-dot-wrapper__step-indicator-bar-dot step-indicator-bar-dot-wrapper__step-indicator-bar-dot--done"></div>;
  }
  return <div className="step-indicator-bar-dot-wrapper__step-indicator-bar-dot step-indicator-bar-dot-wrapper__step-indicator-bar-dot--not-viewed"></div>;
}
